import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ToneAudioNode } from "./ToneAudioNode";
import { Param } from "./Param";
import { onContextClose, onContextInit } from "./ContextInitialization";
/**
 * Tone.Listener is a thin wrapper around the AudioListener. Listener combined
 * with [[Panner3D]] makes up the Web Audio API's 3D panning system. Panner3D allows you
 * to place sounds in 3D and Listener allows you to navigate the 3D sound environment from
 * a first-person perspective. There is only one listener per audio context.
 */

export var Listener = /*#__PURE__*/function (_ToneAudioNode) {
  _inherits(Listener, _ToneAudioNode);

  var _super = _createSuper(Listener);

  function Listener() {
    var _this;

    _classCallCheck(this, Listener);

    _this = _super.apply(this, arguments);
    _this.name = "Listener";
    _this.positionX = new Param({
      context: _this.context,
      param: _this.context.rawContext.listener.positionX
    });
    _this.positionY = new Param({
      context: _this.context,
      param: _this.context.rawContext.listener.positionY
    });
    _this.positionZ = new Param({
      context: _this.context,
      param: _this.context.rawContext.listener.positionZ
    });
    _this.forwardX = new Param({
      context: _this.context,
      param: _this.context.rawContext.listener.forwardX
    });
    _this.forwardY = new Param({
      context: _this.context,
      param: _this.context.rawContext.listener.forwardY
    });
    _this.forwardZ = new Param({
      context: _this.context,
      param: _this.context.rawContext.listener.forwardZ
    });
    _this.upX = new Param({
      context: _this.context,
      param: _this.context.rawContext.listener.upX
    });
    _this.upY = new Param({
      context: _this.context,
      param: _this.context.rawContext.listener.upY
    });
    _this.upZ = new Param({
      context: _this.context,
      param: _this.context.rawContext.listener.upZ
    });
    return _this;
  }

  _createClass(Listener, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Listener.prototype), "dispose", this).call(this);

      this.positionX.dispose();
      this.positionY.dispose();
      this.positionZ.dispose();
      this.forwardX.dispose();
      this.forwardY.dispose();
      this.forwardZ.dispose();
      this.upX.dispose();
      this.upY.dispose();
      this.upZ.dispose();
      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(ToneAudioNode.getDefaults(), {
        positionX: 0,
        positionY: 0,
        positionZ: 0,
        forwardX: 0,
        forwardY: 0,
        forwardZ: -1,
        upX: 0,
        upY: 1,
        upZ: 0
      });
    }
  }]);

  return Listener;
}(ToneAudioNode); //-------------------------------------
// 	INITIALIZATION
//-------------------------------------

onContextInit(function (context) {
  context.listener = new Listener({
    context: context
  });
});
onContextClose(function (context) {
  context.listener.dispose();
});